import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import type { Id } from "@/convex/_generated/dataModel";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { ConnectionDetail } from "@/components/integrations/connection-detail";

// Sin `tab` en la URL la pestaña la decide la conexion: "worker" si el plugin
// lo necesita (es la primera pestaña), "triggers" si no.
const searchSchema = z.object({
  tab: z.enum(["triggers", "executions", "worker"]).optional(),
});

export const Route = createFileRoute("/_authenticated/settings/_layout/integrations/$connectionId")({
  validateSearch: searchSchema,
  component: IntegrationConnectionPage,
});

function IntegrationConnectionPage() {
  const { connectionId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <RouteGuardPermissions permissions={[{ module: "integrations", actions: ["read"] }]}>
      <ConnectionDetail
        connectionId={connectionId as Id<"integration_connections">}
        tab={tab}
        onTabChange={(next) =>
          void navigate({ search: { tab: next as "triggers" | "executions" | "worker" }, replace: true })
        }
      />
    </RouteGuardPermissions>
  );
}
